<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.facture',1) }}
                    </h3>
                </div>
            </div>

            <div class="" :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form>
                    <div class="" :class="[ mobileView ? '': 'container']">
                        <p class="heading text-center">{{$t('message.infoGenerale')}}</p>

                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="etablissement-group"
                                        :label="$t('message.nomEtablissement')"
                                        label-for="etablissement"
                                >
                                    <select id="etablissement" v-model="$v.form.etablissement_id.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('categorie_id')" style="color:red">
                                    {{getErrorsField('categorie_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nomPatient-group"
                                        :label="$t('message.nomPatient')"
                                        label-for="nomPatient"
                                >
                                    <select id="nomPatient" v-model="$v.form.dossier_medical_id.$model"
                                            @change="clearErrorField('dossier_medical_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mPatients" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.dossier_medical_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('dossier_medical_id')" style="color:red">
                                    {{getErrorsField('dossier_medical_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group
                                        id="dateFacturation-group"
                                        :label="$t('message.dateFacturation')"
                                        label-for="dateFacturation">
                                    <b-form-input
                                            id="dateFacturation"
                                            v-model="$v.form.date_facturation.$model"
                                            :state="$v.form.date_facturation.$dirty ? !(errorshasField('date_facturation') || $v.form.date_facturation.$error) : null"
                                            placeholder=""
                                            type="date"
                                            @focus="clearErrorField('date_facturation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_facturation')">
                                        {{ getErrorsField('date_facturation') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_facturation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <p class="heading text-center">{{$t('message.detailsFacture')}}</p>
                        <p class="text-center" v-if="$v.form.prestation.$error" style="color: darkred">Aucune prestation ajouté</p>

                        <b-row v-if="form.prestations.length > 0" class="my-2">
                            <b-col sm="12">
                                <b-table
                                        striped
                                        responsive
                                        hover
                                        :items="form.prestations"
                                        :fields="[
                                        { key: 'name', label: $t('message.nomPrestation')},
                                        { key: 'price', label: $t('message.price')},
                                        { key: 'reduction', label: $t('message.remise')},
                                        { key: 'id', label: $tc('message.actions', 1)},
                                    ]"
                                >
                                    <template v-slot:cell(name)="data">
                                        <p class="mb-0 capitalize-first-letter">{{ data.value }}</p>
                                    </template>

                                    <template v-slot:cell(id)="data">
                                        <b-button class="btn-sm" @click="retirerPrestation(data.value)" variant="danger">
                                            {{ $t('message.delete') }}
                                        </b-button>
                                    </template>

                                    <!-- Optional default data cell scoped slot -->
                                    <template v-slot:cell()="data">
                                        <p>{{ data.value }}</p>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>

                        <b-row >
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="prestation2-group"
                                        :label="$t('message.nomPrestation')"
                                        label-for="prestation2"
                                >
                                    <select id="prestation2" v-model="$v.prestation.prestation_id.$model"
                                            @change="clearErrorField('prestation_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mPrestations" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prestation.prestation_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('prestation_id')" style="color:red">
                                       {{getErrorsField('prestation_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="datePrestation-group"
                                        :label="$t('message.datePrestation')"
                                        label-for="datePrestation">
                                    <b-form-input
                                            id="datePrestation"
                                            :value="$v.prestation.date_prestation.$model"
                                            :state="$v.prestation.date_prestation.$dirty ? !(errorshasField('date_prestation') || $v.prestation.date_prestation.$error) : null"
                                            type="date"
                                            @focus="clearErrorField('date_prestation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_prestation')">
                                        {{ getErrorsField('date_prestation') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.prestation.date_prestation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

<!--                        <b-row class="justify-content-sm-center">-->
<!--                            <b-button @click="ajouterALaListe" variant="dark">-->
<!--                                {{ $t('message.ajouterDetail') }}-->
<!--                            </b-button>-->
<!--                        </b-row>-->

<!--                        <b-row>-->
<!--                            <b-col sm="12">-->
<!--                                <span  class="obligatoire">*</span>-->
<!--                                <b-form-group-->
<!--                                        id="totalHorsRemise-group"-->
<!--                                        :label="$t('message.totalHorsRemise')"-->
<!--                                        label-for="totalHorsRemise">-->
<!--                                    <b-form-input-->
<!--                                            id="totalHorsRemise"-->
<!--                                            v-model="$v.form.total_hors_remise.$model"-->
<!--                                            :state="$v.form.total_hors_remise.$dirty ? !(errorshasField('total_hors_remise') || $v.form.total_hors_remise.$error) : null"-->
<!--                                            placeholder=""-->
<!--                                            type="number"-->
<!--                                            step="0.01"-->
<!--                                            @focus="clearErrorField('total_hors_remise')"-->
<!--                                    ></b-form-input>-->

<!--                                    <b-form-invalid-feedback v-if="errorshasField('total_hors_remise')">-->
<!--                                        {{ getErrorsField('total_hors_remise') }}-->
<!--                                    </b-form-invalid-feedback>-->

<!--                                    <b-form-invalid-feedback v-if="$v.form.total_hors_remise.$error">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->
<!--                                </b-form-group>-->
<!--                            </b-col>-->

<!--                            <b-col sm="12">-->
<!--                                <span  class="obligatoire">*</span>-->
<!--                                <b-form-group-->
<!--                                        id="remise-group"-->
<!--                                        :label="$t('message.remise')"-->
<!--                                        label-for="remise">-->
<!--                                    <b-form-input-->
<!--                                            id="remise"-->
<!--                                            v-model="$v.form.remise.$model"-->
<!--                                            :state="$v.form.remise.$dirty ? !(errorshasField('remise') || $v.form.remise.$error) : null"-->
<!--                                            placeholder=""-->
<!--                                            type="number"-->
<!--                                            step="0.01"-->
<!--                                            @focus="clearErrorField('remise')"-->
<!--                                    ></b-form-input>-->

<!--                                    <b-form-invalid-feedback v-if="errorshasField('remise')">-->
<!--                                        {{ getErrorsField('remise') }}-->
<!--                                    </b-form-invalid-feedback>-->

<!--                                    <b-form-invalid-feedback v-if="$v.form.remise.$error">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->
<!--                                </b-form-group>-->
<!--                            </b-col>-->

<!--                            <b-col sm="12">-->
<!--                                <span  class="obligatoire">*</span>-->
<!--                                <b-form-group-->
<!--                                        id="totalAvecRemise-group"-->
<!--                                        :label="$t('message.totalAvecRemise')"-->
<!--                                        label-for="totalAvecRemise">-->
<!--                                    <b-form-input-->
<!--                                            id="totalAvecRemise"-->
<!--                                            :value="$v.form.total_avec_remise.$model = form.total_hors_remise - form.remise"-->
<!--                                            type="number"-->
<!--                                            disabled-->
<!--                                            @focus="clearErrorField('total_avec_remise')"-->
<!--                                    ></b-form-input>-->

<!--                                    <b-form-invalid-feedback v-if="errorshasField('total_avec_remise')">-->
<!--                                        {{ getErrorsField('total_avec_remise') }}-->
<!--                                    </b-form-invalid-feedback>-->

<!--                                    <b-form-invalid-feedback v-if="$v.form.total_avec_remise.$error">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->
<!--                                </b-form-group>-->
<!--                            </b-col>-->

<!--                        </b-row>-->

                        <b-row>

                        </b-row>
                        <!--                        <b-row class="justify-content-sm-center" v-if="can && !continuer">-->
                        <!--                            <b-button @click="validerForm" variant="primary">-->
                        <!--                                {{ $t('message.continuer') }}-->
                        <!--                            </b-button>-->
                        <!--                        </b-row>-->

                        <b-row class="d-flex justify-content-center">
                          <b-button @click="ajouterALaListe" variant="dark" class="pr-2 pb-2">
                            {{ $t('message.ajouterDetail') }}
                          </b-button>

                            <b-button @click="onSubmit" variant="primary" :disabled="form.prestation.length==0" class="pb-2">
                                {{ $t('message.enregistrerFacture') }}
                            </b-button>
                        </b-row>
                    </div>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import {required} from "vuelidate/lib/validators";
    import SlimSelect from "slim-select";
    import moment from "moment";

    export default {
        name: "Add",
        computed: {
            ...mapGetters(['hasAdminRole', "userInstitutions","errors",
                'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            mPrestations:function(){
                let pArray = [];
                if (_.isNull(this.form.etablissement_id)){
                    return [];
                }else{
                    let self = this;
                    let etablissement = _.find(self.userInstitutions,function (institution) {
                        return institution.id == self.form.etablissement_id;
                    });
                    let prestations = etablissement.prestations
                    _.forEach(prestations,function (prestation) {
                        //Ici nous allons conserver le nom des prestations et les identifiants de  prestation pour etablissement
                        pArray.push({nom:prestation.prestation.nom,id:prestation.id,prix:prestation.prix,reduction:prestation.reduction});
                    })
                }
                return pArray;
            },

            mPatients:function(){
                let pArray = [];
                if (_.isNull(this.form.etablissement_id)){
                    return [];
                }else{
                    let self = this;
                    let etablissement = _.find(self.userInstitutions,function (institution) {
                        return institution.id == self.form.etablissement_id;
                    });

                    let patients = etablissement.patients;
                    pArray = [];
                    _.forEach(patients , function (patient) {
                        let id = patient.dossier.id;
                        let nom =patient.user.nom + ' ' + (_.isNull(patient.user.prenom) ? '' :patient.user.prenom);

                        if (_.isUndefined(_.find(pArray, function (p) {
                            return p.id == id;
                        }))){
                            pArray.push({nom:nom,id:id});
                        }
                    })
                    return  pArray;
                }
            },

            mInstitutions:function () {
                let iArray = [];
                _.forEach(this.userInstitutions, function (institution) {
                    iArray.push({nom:institution.name, id:institution.id});
                })
                return iArray;
            }
        },

        data(){
            return {
                mobileView: true,
                continuer:false,
                prestationSelect:Object,
                prestation:{
                    date_prestation:moment((new Date())).format('YYYY-MM-DD'),
                    prestation_id:null
                },
                total_avec_remise:0,
                form : {
                    prestation: [],

                    // For UI purpose
                    prestations: [],
                    dossier_medical_id:null,
                    etablissement_id:null,
                    total_hors_remise:0,
                    total_avec_remise:0,
                    date_facturation: moment((new Date())).format('YYYY-MM-DD'),
                    motif:'',
                    statut:'',
                    remise:0,
                }
            }
        },
        watch:{
            // 'form.prestation': function(newValue, oldValue) {
            // 	this.form.prestations = newValue.map(item => {
            // 		const _prestation = this.getPrestation(item.prestation_id);
            // 		return {
            // 			name: _prestation.nom,
            // 			price: _prestation.prix,
            // 			id: _prestation.id,
            // 			reduction: _prestation.reduction,
            // 		};
            //     });
            // },
        },
        methods:{
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
            onFactureClick(params){
                this.$router.push({ name: 'facture', params: { facture: params.row.slug } });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            validerForm(evt){
                evt.preventDefault();

                this.$v.form.$touch();

                if(!this.$v.form.$invalid) {
                    this.continuer = true;
                }
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        dossier_medical_id:this.form.dossier_medical_id,
                        etablissement_id:this.form.etablissement_id,
                        total_hors_remise:''+this.form.total_hors_remise,
                        total_avec_remise:''+this.form.total_avec_remise,
                        date_facturation:this.form.date_facturation,
                        motif:'',
                        statut:'Généré',
                        remise:''+this.form.remise,
                        prestation:this.form.prestation
                    };

                    let successMessage = this.$i18n.t('message.factureCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createFacture', { args, errorMessages, successMessage })
                }
            },

            ajouterALaListe(){
                let item = {};
                if (this.prestation.prestation_id != null){
                    item.prestation_id = this.prestation.prestation_id;
                    item.date_prestation = this.prestation.date_prestation;

                    const isAlreadyExist = this.form.prestation.findIndex(i => i.prestation_id === item.prestation_id);

                    // Check if the item already exists
                    if (isAlreadyExist === -1) {
                        let _prestation = this.getPrestation(item.prestation_id);
                        let item2 = {
                            name: _prestation.nom,
                            price: _prestation.prix,
                            id: _prestation.id,
                            reduction: _prestation.reduction,
                        };
                        this.form.prestation.push(item);
                        this.form.prestations.push(item2);
                    }

                    this.$v.prestation.prestation_id.$reset();
                }
            },

            getPrestation(id){
                return _.find(this.mPrestations, function (prestation) {
                    return prestation.id == id;
                })
            },
            retirerPrestation(id){
                this.form.prestations = this.form.prestations.filter(item => item.id != id);
                this.form.prestation = this.form.prestation.filter(item => item.prestation_id != id);
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
        },

        validations() {
            return {
                form : {
                    prestation:{required},
                    dossier_medical_id: {required},
                    etablissement_id:{required},
                    total_hors_remise:{required},
                    total_avec_remise:{required},
                    date_facturation:{required},
                    motif:{},
                    statut:{},
                    remise:{},
                },
                prestation:{
                    date_prestation:{required},
                    prestation_id:{required}
                }
            }
        },
        created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
        mounted() {
            this.getUserInstitutions();


            var prestation =  new SlimSelect({
                select: '#prestation2',
                placeholder: 'Select prestation',
            });

            new SlimSelect({
                select: '#etablissement',
                placeholder: 'Select etablissement',
                limit: 1
            });

            new SlimSelect({
                select: '#nomPatient',
                placeholder: 'Select patient',
                limit: 1
            });

            this.prestationSelect = prestation;
        }
    }
</script>

<style scoped>
    @import "~slim-select/dist/slimselect.min.css";
</style>
